/**
 * Order Details
 */

// React
import React, { useState, useEffect, useContext } from "react";

// Context
import AuthContext from "../../authContext";

// Redux
import { connect } from "react-redux";
import { compose } from "redux";
import { Store } from "../../redux/reducers";
import {
  clearOrderAction,
  getAllOrderItemsAction,
  getOrderWithIdAction,
  updateOrderStatusActions,
  getLogsAction,
} from "../orders/actions";

// Selector
import { createStructuredSelector } from "reselect";
import {
  makeSelectOrder,
  makeSelectLoading,
  makeSelectError,
  makeSelectAllOrderItems,
  makeSelectLogs,
} from "../orders/selectors";

//UI
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import theme from "../../theme";
import {
  Dialog,
  DialogContent,
  Typography,
  DialogActions,
  Paper,
  Grid,
  Button,
  Divider,
  CircularProgress,
  Radio,
  RadioGroup,
  Select,
  FormControl,
  FormControlLabel,
  IconButton,
  Box,
  TextField,
  Card,
  CardHeader,
  CardContent,
} from "@material-ui/core";

import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from "@material-ui/lab";

// Icon
import Icon from "@mdi/react";
import {
  mdiArrowRight,
  mdiPencilOutline,
  mdiClose,
  mdiPrinter,
  mdiKey,
  mdiReceipt,
  mdiPackageVariant,
  mdiStoreOutline,
  mdiTextBoxMultipleOutline,
  mdiDotsHorizontalCircleOutline,
  mdiPackageVariantClosed,
  mdiTruckFastOutline,
  mdiMapMarkerCheckOutline,
  mdiClipboardAlertOutline,
  mdiClipboardArrowDownOutline,
  mdiClipboardCheckOutline,
  mdiPlusBoxMultipleOutline,
  mdiAccountArrowRight,
  mdiTableEye,
  mdiEmail,
} from "@mdi/js";

// Components
import ListOrderItems from "./list";
import InventoryItemsList from "./inventoryItemsList";
import JalaliUtils from "@date-io/jalaali";
import Can from "../../components/Can";
import DeliveryReceipt from "./deliveryReceipt";

// Helper
import {
  translateOrderStatus,
  translateUserRoles,
  convertPersianDigit2English,
} from "../../utils/helpers";
import jMoment from "moment-jalaali";

// Type

import { Status, Log } from "../orders/interfaces";
import { SelectorProps, Props } from "./interfaces";
import { Link } from "react-router-dom";
import CSV from "./csv";
import { UpdateOrderPostTrackingCode } from "client-sdk/src/orders/orders";
import Client from "client-sdk/src/client";
import handleNotfication from "../../utils/handleNotfication";
import { getInventoryItemsWithSerialAction } from "../parcels/actions";
import Modal from "../../components/Modal";
import { makeSelectInventoryItemsWithSerialList } from "../parcels/selectors";
import { MuiPickersUtilsProvider, TimePicker } from "@material-ui/pickers";
import ordersRepository from "client-sdk/src/Repository/orders-repository";
import handleError from "../../utils/handleError";
import Detailwithedit from "../../components/cards/order/detailwithedit";
import { getAllTicket } from "../../api/ticket/get";

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& > *": {
        "@media (max-width: 768px)": {
          margin: theme.spacing(0),
        },
      },
    },
    textInput: {
      color: "#8a8a8a",
      "& input, .MuiSelect-root": {
        padding: "6px 0 12px !important",
      },

      "& .MuiInput-underline::before": {
        borderBottom: "1px solid #d8d8d8 !important",
      },
    },
    typographyCards: {
      fontSize: "16px",
      color: "white",
      backgroundColor: "#4BCF90",
      padding: "8px 24px 8px 50px",
      marginLeft: "-40px",
    },
    paper: {
      marginTop: "36px",
      marginBottom: "36px",
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: "1px solid #ddd",
      borderRadius: "4px",
    },
    addIcon: {
      textAlign: "center",
      position: "relative",
      paddingLeft: theme.spacing(8),
      "&::before": {
        content: '""',
        position: "absolute",
        width: "100px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "100px",
        borderRadius: "50%",
        opacity: "0.2",
        backgroundColor: "#5c5c5c",
      },
    },
    card: {
      marginBottom: "32px",
      overflow: "visible",
      padding: "14px",
    },

    cardDivider: {
      width: "100%",
      marginRight: "auto",
    },
    item: {
      marginBottom: "30px",
      display: "flex",
      alignSelf: "center",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    rtlIcon: {
      marginRight: theme.spacing(1),
      transform: "scale(-1, 1)",
    },
    divider: {
      width: "98%",
      margin: "10px auto",
    },
    label: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 400,
      color: "#8A8A8A",
      marginRight: "auto",
    },
    headerBox: {
      display: "flex",
      alignItems: "center",
      marginBottom: "28px",
    },
    contentlabelTitle: {
      position: "relative",
      color: theme.palette.gray.light,
      marginLeft: "40px",
      fontSize: "14px",
      fontWeight: 500,
      "&:before": {
        content: '"-"',
        position: "absolute",
        left: "-20px",
      },
    },
    loading: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: "50vh",
      alignSelf: "center",
      justifyContent: "center",
      background: "#ccc",
    },
    changStatusIcon: {
      marginRight: "10px",
      position: "absolute",
    },
    changStatusBox: {
      display: "flex",
      textAlign: "left",

      fontWeight: 400,
      fontSize: "14px",
    },
    renderValue: {
      paddingLeft: "32px",
    },
    radioGroup: {
      margin: "-8px 0",
    },
    radioGroupItem: {
      borderBottom: "1px solid #D8D8D8",
      marginRight: "-8px",
      padding: "8px 16px",
      "&:last-child": {
        borderBottom: "0px",
      },
    },
    cancelTitle: {
      fontSize: "16px",
      fontWeight: 500,
      textAlign: "justify",
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: "center",
      position: "relative",
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      "&::before": {
        content: '""',
        position: "absolute",
        width: "100px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "100px",
        borderRadius: "50%",
        opacity: "0.2",
        backgroundColor: theme.palette.blue.main,
      },
    },

    missingOppositeContent: {
      "&::before": {
        flex: "none",
      },
    },
    paperHistory: {
      "@media (min-width: 768px)": {
        width: "40%",
      },
      alignItems: "center",
    },
    titleBox: {
      paddingTop: "10px",
      // backgroundColor: theme.palette.primary.main,
      // color: theme.palette.secondary.contrastText,
      // padding: theme.spacing(2),
      // borderRadius: '4px 4px 0 0',
    },
    contentBox: {
      marginTop: "-20px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      padding: theme.spacing(2),
      fontSize: "14px",
      fontWeight: 500,
    },
    contentlabel: {
      color: theme.palette.gray.light,
      marginRight: "10px",
      fontWeight: 400,
    },
  })
);

const colorStatus = {
  ARRIVED: theme.palette.green.main, //'به مقصد رسیده',
  BUNDLED: theme.palette.green.main, //' بسته‌بندی شده برای راننده',
  CANCELLED: theme.palette.error.main, //'لغو شده',
  DELIVERED_TO_POST: theme.palette.green.main, //'ارسال شده',
  DELIVERED_TO_CENTER: theme.palette.green.main, //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: theme.palette.green.main, //'تامین در مرکز',
  PACKAGED: theme.palette.green.main, //'بسته بندی شده برای مشتری',
  DELIVERED: theme.palette.green.main, //'تحویل داده شده',
  LOADED: theme.palette.green.main, // 'در حال تحویل',
  NOT_DELIVERED: theme.palette.orange.main, //'تحویل داده نشده',
  ORDERED: theme.palette.green.main, //'ایجاد شده',
  RETURNED: theme.palette.neutral.main, //'بازگردانده شده',
  PICKED: theme.palette.orange.main, //'بازگردانده شده',
  ASSIGNED: theme.palette.blue.main, //'بازگردانده شده',
};

const iconStatus = {
  ARRIVED: mdiMapMarkerCheckOutline, //'به مقصد رسیده',
  BUNDLED: mdiPackageVariantClosed, //' بسته‌بندی شده برای راننده',
  CANCELLED: mdiClose, //'لغو شده',
  DELIVERED_TO_POST: mdiDotsHorizontalCircleOutline, //'ارسال شده',
  DELIVERED_TO_CENTER: mdiDotsHorizontalCircleOutline, //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: mdiDotsHorizontalCircleOutline, //'تامین در مرکز',
  PACKAGED: mdiPackageVariant, //'بسته بندی شده برای مشتری',
  DELIVERED: mdiClipboardCheckOutline, //'تحویل داده شده',
  LOADED: mdiTruckFastOutline, // 'در حال تحویل',
  NOT_DELIVERED: mdiClipboardAlertOutline, //'تحویل داده نشده',
  ORDERED: mdiDotsHorizontalCircleOutline, //'ایجاد شده',
  RETURNED: mdiClipboardArrowDownOutline, //'بازگردانده شده',
  PICKED: mdiPlusBoxMultipleOutline, //'برداشته شده',
  ASSIGNED: mdiAccountArrowRight, //'برداشته شده',
};

export function Details(props: Props) {
  const authContext = useContext(AuthContext);
  const [previewState, setPreviewState] = useState("CANCELLED" as Status);
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const [openInventoryItems, setOpenInventoryItems] = useState(
    false as boolean
  );
  const [openDelaySMS, setOpenDelaySMS] = useState(false as boolean);
  const [delayTime, setDelayTime] = useState<string | undefined>(undefined);
  const [postTrackingCode, setPostTrackingCode] = useState<null | string>(null);
  const [oldTicket, setOldTicket] = useState([]);

  const classes = useStyles();
  const token = localStorage.getItem("token") || "";

  const getOldTicket = async (id: number) => {
    try {
      const res = await getAllTicket({ linkType: "order", linkId: id });
      setOldTicket(res.data.content);
    } catch (error) {
      handleError(error);
    }
  };

  useEffect(() => {
    const { id } = props.match.params;
    props.orderWithIdActionDispatch(id);
    props.getOrderItemsActionDispatch({
      "orderId.equals": id,
      page: 0,
      size: 1000,
    });
    getOldTicket(id);
  }, []);

  useEffect(() => {
    props.getLogsDispatch(props.match.params.id);
    if (props.order?.postTrackingCode) {
      setPostTrackingCode(props.order?.postTrackingCode);
    }
  }, [props.order]);

  useEffect(() => {
    return () => {
      props.clearOrderActionDispatch();
    };
  }, []);

  const changeStatusOrder = () => {
    const { id } = props.match.params;
    props.updateOrderStatusDispatch({
      id: props.order.id,
      body: previewState.replace(/"/g, ""),
      pagination: {},
      callback: () => props.orderWithIdActionDispatch(id),
    });
    handleClose();
  };

  const handleChangeTrackingCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPostTrackingCode(e.target?.value!);
  };

  const submitPostTrackingCode = async () => {
    // @ts-ignore
    try {
      const { id } = props.match.params;
      const makeRequest = new UpdateOrderPostTrackingCode()
        .id(id)
        .data(postTrackingCode)
        .build();
      const client = new Client(token);
      await client.execute(makeRequest);
      handleNotfication("کد پیگیری پست با موفقیت ثبت شد", "success");
      props.orderWithIdActionDispatch(id);
    } catch (err) {
      handleNotfication(
        "تغییر کد پیگیری پست ثبت نشد دوباره تلاش کنید",
        "error"
      );
    }
  };

  const handleShowInventoryItems = (data: any) => {
    props.getInventoryItems({
      orderItemId: { equals: data.id },
      callback: () => setOpenInventoryItems(true),
    });
  };

  const handleOpenConfirmUpdateState = (body: Status) => {
    setOpenConfirmUpdateState(true);
    setPreviewState(body);
  };

  const handleClose = () => {
    setOpenConfirmUpdateState(false);
  };

  const handleCloseDelaySMS = () => {
    setDelayTime(null);
    setOpenDelaySMS(false);
  };

  const sendSMS = async () => {
    const { id } = props.match.params;
    const payload = { id, body: `"` + delayTime.slice(-5) + `"` };
    try {
      await ordersRepository.sendDelayDeliveryOrderTimeSms({ payload });
      handleCloseDelaySMS();
      handleNotfication("پیامک با موفقیت ارسال شد", "success");
    } catch (err) {
      handleError(err);
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.headerBox}>
        <Typography variant="h6" component="h2">
          {`
        جزيیات سفارش
     
        `}
        </Typography>

        <span className={classes.contentlabelTitle}>{props.order.id}</span>
      </div>
      <div style={{ marginBottom: "25px" }}>
        <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}>
          <Icon path={mdiArrowRight} size={1} className={classes.icon} />
          {"بازگشت"}
        </Button>
      </div>
      <Grid container item lg={12} md={12} spacing={4}>
        <Grid item lg={3} md={3} spacing={2}>
          {props.order?.deliveryType !== "COURIER" && (
            <Card className={classes.card}>
              <CardHeader
                avatar={
                  <Typography className={classes.typographyCards}>
                    مشخصات مرسوله پستی
                  </Typography>
                }
              />
              <CardContent>
                <Grid xs={12} sm={12} lg={12} spacing={2}>
                  {props.order?.postOrders?.map((order, index) => {
                    return (
                      <>
                        <Grid item xs={12} sm={12}>
                          <div className={classes.item}>
                            <span style={{ fontSize: "18px" }}>
                              بسته {index + 1}
                            </span>
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <div className={classes.item}>
                            <span className={classes.label}>
                              {"وضعیت مرسوله:  "}
                            </span>
                            <span>
                              {translateOrderStatus(order.orderStatus)}
                            </span>
                          </div>
                        </Grid>
                        {order.barcode && (
                          <Grid item xs={12} sm={12}>
                            <div className={classes.item}>
                              <span className={classes.label}>
                                {"کد رهگیری پست:  "}
                              </span>
                              <a
                                target="_blank"
                                href={`https://tracking.post.ir/search.aspx?id=${order.barcode}`}>
                                <span data-cy="trackingCode">
                                  {order.barcode}
                                </span>
                              </a>
                            </div>
                          </Grid>
                        )}
                        {order.weight && (
                          <Grid item xs={12} sm={12}>
                            <div className={classes.item}>
                              <span className={classes.label}>
                                {"وزن پستی (گرم):  "}
                              </span>
                              <span>{order.weight}</span>
                            </div>
                          </Grid>
                        )}
                        {order.totalPrice && (
                          <Grid item xs={12} sm={12}>
                            <div className={classes.item}>
                              <span className={classes.label}>
                                {"هزینه پست (ریال):  "}
                              </span>
                              <span>{order.totalPrice}</span>
                            </div>
                          </Grid>
                        )}
                      </>
                    );
                  })}
                </Grid>
              </CardContent>
            </Card>
          )}
          <Detailwithedit order={props.order} />
          <DeliveryReceipt
            loading={props.loading}
            files={props.order.files}
            orderId={props.order.id}
          />
        </Grid>
        <Grid item lg={9} md={9} spacing={2}>
          <Grid container>
            <Button
              variant="contained"
              color="secondary"
              startIcon={<Icon path={mdiEmail} size={1} />}
              onClick={() => setOpenDelaySMS(true)}
              style={{ marginRight: "auto", marginBottom: "8px" }}>
              {"پیامک تاخیر"}
            </Button>
          </Grid>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  لیست کالاهای سفارش {props.order.id}
                </Typography>
              }
              action={
                <Grid item xs={12} style={{ marginTop: "15px" }}>
                  <div style={{ textAlign: "left" }}>
                    <Can
                      role={authContext.user.role}
                      perform="orders:downloadReportCSV"
                      yes={() => (
                        <>
                          <CSV
                            // ordersDispatch={props.order}
                            data={props.orderItems}
                            loading={props.loading}
                          />
                        </>
                      )}
                    />
                    {oldTicket.length > 0 && (
                      <Link to={`/ticketing/${oldTicket[0].id}`}>
                        <Button
                          style={{ marginLeft: "12px" }}
                          variant="contained"
                          size="large"
                          color="primary"
                          // style={{ marginLeft: '172px' }}
                        >
                          {`سابقه تیکت`}
                        </Button>
                      </Link>
                    )}
                  </div>
                </Grid>
              }
            />
            <CardContent style={{ margin: "14px 0  0", padding: "0" }}>
              <Grid container spacing={3}>
                {props.loading ? (
                  <div className={classes.loading}>
                    <CircularProgress />
                  </div>
                ) : (
                  props.order?.items && (
                    <>
                      <ListOrderItems
                        data={props.orderItems}
                        showItems={(data) => handleShowInventoryItems(data)}
                      />
                    </>
                  )
                )}
              </Grid>
            </CardContent>
          </Card>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  تاریخچه سفارش
                </Typography>
              }
            />
            <CardContent style={{ margin: "14px 0 0 0", padding: "0" }}>
              <Grid container>
                <Grid item xs={12}>
                  <Timeline align="left">
                    {props.logs
                      ?.slice()
                      .reverse()
                      .map((log: Log, index: number) => (
                        <TimelineItem
                          style={{ flex: "none" }}
                          className={classes.missingOppositeContent}
                          key={index}>
                          <TimelineSeparator>
                            <TimelineDot
                              style={{
                                backgroundColor: colorStatus[log.newStatus],
                                border: index === 0 ? "solid 4px #DF9234" : "",
                              }}>
                              <Icon path={iconStatus[log.newStatus]} size={1} />
                            </TimelineDot>
                            {index !== props.logs?.length - 1 ? (
                              <TimelineConnector />
                            ) : (
                              ""
                            )}
                          </TimelineSeparator>
                          <TimelineContent className={classes.paperHistory}>
                            <div style={{ padding: "10px" }}>
                              <div className={classes.contentBox}>
                                <div>
                                  <span className={classes.contentlabel}>
                                    وضعیت سفارش:
                                  </span>
                                  <span>
                                    {translateOrderStatus(log.newStatus)}
                                  </span>
                                </div>
                                <div>
                                  <span className={classes.contentlabel}>
                                    کاربر:
                                  </span>
                                  <Can
                                    role={authContext.user.role}
                                    perform="user-name:dontShowInLogs"
                                    no={() => (
                                      <>
                                        <span>{log.modifierName}</span>
                                        <span>
                                          {" "}
                                          &nbsp; &nbsp;- &nbsp; &nbsp;
                                        </span>
                                      </>
                                    )}
                                  />
                                  <span>
                                    {translateUserRoles(log.modifierRole)}
                                  </span>
                                </div>
                                <Typography
                                  component="div"
                                  className={classes.titleBox}>
                                  {log.time &&
                                    jMoment(log.time, "YYYY/MM/DDTHH:mm:ss.SSZ")
                                      .locale("fa")
                                      .format("jYYYY/jMM/jDD - HH:mm")}
                                </Typography>
                                {log.description && (
                                  <div style={{ marginTop: "12px" }}>
                                    <span className={classes.contentlabel}>
                                      توضیحات:
                                    </span>
                                    <span>{log.description}</span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </TimelineContent>
                        </TimelineItem>
                      ))}
                  </Timeline>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item lg={3} md={3} spacing={2}></Grid>
      </Grid>
      <Dialog
        fullWidth
        open={openDelaySMS}
        onClose={handleCloseDelaySMS}
        aria-labelledby="responsive-dialog-title">
        <DialogContent>
          <div
            style={{
              position: "absolute",
              left: "17px",
              zIndex: 10,
            }}>
            <IconButton
              aria-label="close"
              // className={classes.closeButton}
              onClick={handleCloseDelaySMS}>
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <div className={classes.editIcon}>
            <Icon
              path={mdiPencilOutline}
              size={4}
              color={theme.palette.blue.main}
            />
          </div>
          <div className={classes.cancelTitle}>
            <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
              <TimePicker
                fullWidth
                label={"زمان"}
                variant="inline"
                ampm={false}
                format="HH:mm"
                className={classes.textInput}
                autoOk
                clearable
                labelFunc={(date) =>
                  date?.isValid() ? date.format("HH:mm") : ""
                }
                value={delayTime}
                name="delayTime"
                id="delayTime"
                onChange={(value) => {
                  return setDelayTime(
                    value &&
                      convertPersianDigit2English(
                        value.format("jYYYY/jMM/jDD HH:mm")
                      )
                  );
                }}
              />
            </MuiPickersUtilsProvider>
          </div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                onClick={handleCloseDelaySMS}
                variant="contained"
                color="secondary"
                size="large">
                {"خیر"}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={sendSMS}
                size="large">
                {"بله"}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      {/* <Modal
        onClose={() => setOpenInventoryItems(false)}
        maxWidth="md"
        open={openInventoryItems}
        title={
          <div className={classes.addIcon}>
            <Icon
              path={mdiStoreOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={<InventoryItemsList data={props.inventoryItems} />}
      /> */}
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  logs: makeSelectLogs(),

  order: makeSelectOrder(),
  orderItems: makeSelectAllOrderItems(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
  inventoryItems: makeSelectInventoryItemsWithSerialList(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getLogsDispatch: (id: number) => dispatch(getLogsAction({ id })),
    orderWithIdActionDispatch: (id: number) =>
      dispatch(getOrderWithIdAction({ id })),
    orderWithIdActionDispatch: (id: number) =>
      dispatch(getOrderWithIdAction({ id })),
    updateOrderStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
      callback?: () => void;
    }) => dispatch(updateOrderStatusActions(payload)),
    clearOrderActionDispatch: () => dispatch(clearOrderAction()),
    getInventoryItems: (payload: Record<string, any>) =>
      dispatch(getInventoryItemsWithSerialAction(payload)),
    getOrderItemsActionDispatch: (payload: any) =>
      dispatch(getAllOrderItemsAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Details);
